import React from 'react'
import { Link } from 'react-router-dom'
import './Header.scss'
import { useLanguage } from '../Contexts/LanguageContext'
import Logo from '../Assets/Icons/cinknestlogo.svg'
import LogoMobile from '../Assets/Icons/cinknestlogosygnet.svg'

const Header = () => {
    const { language, setLanguage } = useLanguage()

    const handleLanguageChange = () => {
        setLanguage(language === 'english' ? 'polish' : 'english')
    }




    return (
        <div className='main-header'>
            <div className='top-bar'>
                <div className='language-switcher'>
                <span onClick={handleLanguageChange} className={language === 'english' ? 'blue-color' : 'white-color'}>🇬🇧</span>
                <div className='dot-space'>

                    <div
                        className={`dot ${language === 'english' ? 'en' : 'pl'}`}
                        onClick={handleLanguageChange}
                    ></div>

                </div>
                <span onClick={handleLanguageChange} className={language !== 'english' ? 'blue-color' : 'white-color'}>🇵🇱</span>
            </div>
            </div>
            <div className='bottom-bar'>
                <div className='logo'>
                <Link to='/'>
                    <img src={Logo} alt="clinknest logo" className='desktop-only' />
                    <img src={LogoMobile} alt="clinknest logo" className='mobile-only' />
                </Link>
            </div>
            <div className='nav'>
                <Link to='./login' >
                    <div className='login-btn clinknest-btn'>
                        {language === 'polish' ? (<span>Załóż konto</span>) :(<span>Sign up</span>)}
                    </div>
                </Link>
                <Link to='/moje-konto'>
                    <div className='my-account-link link-with-icon'>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" alt='ikona konta' className='account-icon'>
                            <mask id="mask0_398_45" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                                <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_398_45)">
                                <path d="M5.85 17.6C6.7 16.95 7.65 16.4375 8.7 16.0625C9.75 15.6875 10.85 15.5 12 15.5C13.15 15.5 14.25 15.6875 15.3 16.0625C16.35 16.4375 17.3 16.95 18.15 17.6C18.7333 16.9167 19.1875 16.1417 19.5125 15.275C19.8375 14.4083 20 13.4833 20 12.5C20 10.2833 19.2208 8.39583 17.6625 6.8375C16.1042 5.27917 14.2167 4.5 12 4.5C9.78333 4.5 7.89583 5.27917 6.3375 6.8375C4.77917 8.39583 4 10.2833 4 12.5C4 13.4833 4.1625 14.4083 4.4875 15.275C4.8125 16.1417 5.26667 16.9167 5.85 17.6ZM12 13.5C11.0167 13.5 10.1875 13.1625 9.5125 12.4875C8.8375 11.8125 8.5 10.9833 8.5 10C8.5 9.01667 8.8375 8.1875 9.5125 7.5125C10.1875 6.8375 11.0167 6.5 12 6.5C12.9833 6.5 13.8125 6.8375 14.4875 7.5125C15.1625 8.1875 15.5 9.01667 15.5 10C15.5 10.9833 15.1625 11.8125 14.4875 12.4875C13.8125 13.1625 12.9833 13.5 12 13.5ZM12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.8125 8.1 3.2875C9.31667 2.7625 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8833 21.7375 15.1833 21.2125 16.4C20.6875 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5ZM12 20.5C12.8833 20.5 13.7167 20.3708 14.5 20.1125C15.2833 19.8542 16 19.4833 16.65 19C16 18.5167 15.2833 18.1458 14.5 17.8875C13.7167 17.6292 12.8833 17.5 12 17.5C11.1167 17.5 10.2833 17.6292 9.5 17.8875C8.71667 18.1458 8 18.5167 7.35 19C8 19.4833 8.71667 19.8542 9.5 20.1125C10.2833 20.3708 11.1167 20.5 12 20.5ZM12 11.5C12.4333 11.5 12.7917 11.3583 13.075 11.075C13.3583 10.7917 13.5 10.4333 13.5 10C13.5 9.56667 13.3583 9.20833 13.075 8.925C12.7917 8.64167 12.4333 8.5 12 8.5C11.5667 8.5 11.2083 8.64167 10.925 8.925C10.6417 9.20833 10.5 9.56667 10.5 10C10.5 10.4333 10.6417 10.7917 10.925 11.075C11.2083 11.3583 11.5667 11.5 12 11.5Z" fill="#161616" />
                            </g>
                        </svg>{language === 'polish' ? (<span className='desktop-only'>moje konto</span>) :
                        (<span className='desktop-only'>my account</span>)}
                    </div>
                </Link>
            </div>
            
            </div>
            
        </div>
    )
}

export default Header